import React, {Component} from 'react';
import {bindActionCreators} from "redux";
import {connect} from "react-redux";
import {Button, Input} from 'react-materialize'

import infoActions from "../../actions/workflow/infoStepActions";
import providerType, {odidoProviders} from "../../constants/providerType";
import DatePicker from "../../components/datePicker";
import TechnicalContactApi from "../../services/technicalContactApi";
import CreateNewTechnicalcontactModal from "./createNewTechnicalcontactModal";

const inputPlaceholdersMapping = new Map([
    ["commercialContact", "Commercial"],
    ["technicalContact", "Technical"],
    ["projectManager", "Project manager"],
    ["financialContact", "Financieel contactpersoon"]
  ]
);

class ContactInfo extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchResults: [],
      searching: false,
      /** needed for create new technical contract */
      // open:false,
      // openSearch:false
    };
  }

  handleTechnicalContactSearch = async (query) => {
    if (!this.props.quotation || !this.props.quotation.id) return;
    if (query.length < 2) {
      this.setState({ searchResults: [], searching: false });
      return;
    }

    this.setState({ searching: true });
    try {
      const result = await TechnicalContactApi.searchContacts(this.props.quotation.id, query);
      this.setState({ searchResults: result.contacts, searching: false });
    } catch (err) {
      this.setState({ searching: false, searchResults: [] });
    }
  };

  handleTechnicalContactSelect = async (contact) => {

    /** needed for create new technical contract */
    // if(contact === "new"){
    //   this.setState({searchResults: [], searching: false});
    //   this.setState({open:true})
    //   this.setState({openSearch:false})
    // }else {


      // Sluit de dropdown
      this.setState({searchResults: [], searching: false});
      await this.fillTechnicalContractFields(contact)
      this.setState({openSearch:false})

  };

  fillTechnicalContractFields=async (contact)=>{
    // Vul alle velden met de geselecteerde contact
    const fillEvent = (field, value) => ({
      target: {
        name: 'technicalContact.' + field,
        value: value || ''
      }
    });

    // Vul de velden via de bestaande onChange handler
    this.props.onChangeFunc(fillEvent('fullName', contact.name));
    this.props.onChangeFunc(fillEvent('email', contact.email));
    this.props.onChangeFunc(fillEvent('phoneNumber', contact.phone));

    // Selecteer in backend
    try {
      await TechnicalContactApi.selectTechnicalContact(this.props.quotation.id, contact.connectWiseId);
    } catch (err) {
      console.error('Failed to select contact:', err);
    }

  }

  getTechnicalContactButtons = () => {
    const {
      checked,
      useTechnicalContactForOrder,
      onSameDataFunc,
      updateQuotationProperty,
      isYielderProvider,
      isVenecoOrganization
    } = this.props;

    let sameDataCopyLabel = 'Gelijk aan commercieel contactpersoon';
    let useTechicalForOrderLabel = 'Technisch contactpersoon gebruiken voor het order process';

    if (isYielderProvider) {
      sameDataCopyLabel = 'Gelijk aan gegevens tekenbevoegde';
    }
    if (isVenecoOrganization) {
      sameDataCopyLabel = 'Gelijk aan tekenbevoegde';
    }

    return (
      <div className="technical-person-btn" style={{display: 'flex', flexWrap: 'wrap', flexDirection: 'column'}}>
        <div>
          <input
            name="datacopy"
            className="input-field"
            checked={checked}
            id="same_data_copy"
            type="checkbox"
            onChange={(e) => onSameDataFunc(e.target.checked)}
          />
          <label htmlFor="same_data_copy" style={{fontSize: "15px", fontStyle: "italic"}}>
            {sameDataCopyLabel}
          </label>
        </div>
        {/*{!isYielderProvider &&*/}
        {/*  <div>*/}
        {/*    <input*/}
        {/*        name="useTechnicalContactForOrder"*/}
        {/*        className="input-field"*/}
        {/*        checked={useTechnicalContactForOrder || false}*/}
        {/*        id="useTechnicalContactForOrder"*/}
        {/*        type="checkbox"*/}
        {/*        onChange={(e) => updateQuotationProperty(e)}*/}
        {/*    />*/}
        {/*    <label htmlFor="useTechnicalContactForOrder" style={{fontSize: "15px", fontStyle: "italic"}}>*/}
        {/*      {useTechicalForOrderLabel}*/}
        {/*    </label>*/}
        {/*  </div>*/}
        {/*}*/}
      </div>
    );
  };

  getProjectManagerButtons = () => {
    let {checked, onSameDataFunc} = this.props;

    let sameDataCopyLabel = 'Gelijk aan technisch contactpersoon.';

    return (
      <div className="project-manager-person-btn">
        <input
          name="datacopy-technical"
          className="input-field"
          checked={checked}
          id="same_data_copy_technical"
          type="checkbox"
          onChange={(e) => onSameDataFunc(e.target.checked)}
        />
        <label htmlFor="same_data_copy_technical" style={{fontSize: "15px", fontStyle: "italic"}}>
          {sameDataCopyLabel}
        </label>
      </div>
    );
  };

  onChangeBirthDate = (date) => {
    const syntheticEvent = {
      target: {
        name: this.props.typeOfCustomer + ".birthdate",
        value: date
      }
    };

    this.props.onChangeFunc(syntheticEvent);
  };

  isReadOnly = (field) => {
    const {config, hasConnectWiseSync} = this.props;
    if (!hasConnectWiseSync) {
      return false;
    }

    const {readOnlyFields} = config;

    if (!readOnlyFields) {
      return false;
    }

    if (!readOnlyFields.length) {
      return false;
    }

    return readOnlyFields.includes(field);
  };

  handleCloseModal=()=>{
    this.setState({open:false});
  }

  handleCloseSearch = () => {
    setTimeout(() => {
      if (!this.state.open) {
        this.setState({ openSearch: false, searchResults: [] });
      }
    }, 150);
  };

  render() {
    const {
      typeOfCustomer,
      sectionHeader,
      config,
      checked,
      required,
      onChangeFunc,
      quotation
    } = this.props;

    const nameLabel = sectionHeader.toLowerCase().includes('factuurgegevens') ? 'Factuur contactpersoon' : 'Naam';
    const emailLabel = sectionHeader.toLowerCase().includes('factuurgegevens') ? 'Factuur e-mail' : 'E-mail';

    const isOdidoProvider = quotation.provider === providerType.ODIDO;
    const isOdidoPortfolio = odidoProviders.includes(quotation.provider);
    const isCommercialContact = typeOfCustomer === 'commercialContact';

    let button;
    let additionalClasses = '';
    let hideInput = false;

    if (typeOfCustomer === 'technicalContact') {
      button = this.getTechnicalContactButtons();
      additionalClasses = "technical-person";
      hideInput = checked;
    }

    if (typeOfCustomer === 'projectManager') {
      button = this.getProjectManagerButtons();
      additionalClasses = "project-manager-person";
      hideInput = checked;
    }

    return (
      <div>
        <div className={additionalClasses}>
          <div className="line tussenkop section-header">{sectionHeader}</div>
          {button}
        </div>
        <div className={'row'}>
          <div className={"input-field col s12"} style={{display: (hideInput ? 'none' : 'inline-block'), position: 'relative'}}>
            <input
              type="text"
              name={typeOfCustomer + '.fullName'}
              ref={typeOfCustomer + '.fullName'}
              value={config.fullName}
                /** needed for create new technical contract */
              // onFocus={()=>this.setState({openSearch:true})}
              // onBlur={(e)=>this.handleCloseSearch(e.target.childNodes)}
              onChange={(e) => {
                onChangeFunc(e);
                // Alleen zoeken voor technical contact
                if (typeOfCustomer === 'technicalContact' && quotation && quotation.id) {
                  this.handleTechnicalContactSearch(e.target.value);
                }
              }}
              className="validate"
              required={required}
              readOnly={this.isReadOnly('name')}
              autoComplete="off"
            />
            <label htmlFor="commercialContactFullName">{nameLabel}{required ? ' *' : ''}</label>

            {/* Autocomplete dropdown voor technical contact */}
            {typeOfCustomer === 'technicalContact' && this.state.searchResults.length>0 && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  right: 0,
                  backgroundColor: '#fff',
                  border: '1px solid #ccc',
                  borderRadius: '0 0 3px 3px',
                  maxHeight: '200px',
                  overflowY: 'auto',
                  zIndex: 1000,
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                  {/** needed for create new technical contract */}
                  {/*<div*/}
                  {/*    key={"new"}*/}
                  {/*    onClick={() => this.handleTechnicalContactSelect("new")}*/}
                  {/*    style={{*/}
                  {/*      padding: '10px',*/}
                  {/*      cursor: 'pointer',*/}
                  {/*      borderBottom: '1px solid #eee'*/}
                  {/*    }}*/}
                  {/*    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}*/}
                  {/*    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}*/}
                  {/*>*/}
                  {/*  <strong>{"Nieuw persoon toevoegen"}</strong>*/}

                  {/*</div>*/}
                  {this.state.searchResults.map(contact => (
                      <div
                          key={contact.id}
                          onClick={() => this.handleTechnicalContactSelect(contact)}
                          style={{
                            padding: '10px',
                            cursor: 'pointer',
                            borderBottom: '1px solid #eee'
                          }}
                          onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f0f0'}
                          onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                      >
                        <strong>{contact.name}</strong>
                        <div style={{fontSize: '12px', color: '#666'}}>{contact.email}</div>
                        {contact.phone && <div style={{fontSize: '11px', color: '#999'}}>{contact.phone}</div>}
                      </div>
                  ))}
                </div>
            )}
          </div>

          {/** needed for create new technical contract */}
          {/*{typeOfCustomer === "technicalContact" &&*/}
          {/*    <div className={"input-field col s12 m1 l1"} style={{display: (hideInput ? 'none' : 'inline-block'), position: 'relative'}}>*/}
          {/*      <a className={"btn doceri-btn ratio-btn-steps " }*/}
          {/*         onClick={()=>this.handleTechnicalContactSelect("new")}*/}
          {/*      >*/}
          {/*        +*/}
          {/*      </a>*/}
          {/*    </div>*/}
          {/*}*/}

        </div>

        {sectionHeader.toLowerCase().includes('factuurgegevens') &&
        <div>
          <div className={'row'}>
            <div className="input-field col s12 m8">
              <input
                ref={typeOfCustomer + '.street'}
                type="text"
                name={typeOfCustomer + '.street'}
                value={config.street}
                maxLength="18"
                className="validate"
                required={required}
                onChange={onChangeFunc}
              />
              <label htmlFor="financialContactStreet">Straat{required ? ' *' : ''}</label>
            </div>

            <div className="input-field col s4 m2">
              <input
                type="number"
                ref={typeOfCustomer + '.houseNumber'}
                name={typeOfCustomer + '.houseNumber'}
                value={config.houseNumber}
                onChange={onChangeFunc}
                className="validate"
                pattern="[0-9]"
                required={required}
              />
              <label htmlFor="financialContactHouseNumber">huisnr.</label>
            </div>

            <div className="input-field col s4 m2">
              <input
                type="text"
                ref={typeOfCustomer + '.houseNumberExtension'}
                name={typeOfCustomer + '.houseNumberExtension'}
                minLength="0"
                maxLength="20"
                value={config.houseNumberExtension}
                onChange={onChangeFunc}
                required={required}
              />
              <label htmlFor="financialContactHouseNumberExtension">toev.</label>
            </div>
          </div>

          <div className={'row'}>
            <div className="input-field col s4 m2">
              <input
                type="text"
                ref={typeOfCustomer + '.postalCode'}
                name={typeOfCustomer + '.postalCode'}
                value={config.postalCode}
                onChange={onChangeFunc}
                className="validate"
                required={required}
              />
              <label htmlFor="financialContactPostalCode">Postcode</label>
            </div>

            <div className="input-field col s12 m10">
              <input
                type="text"
                ref={typeOfCustomer + '.city'}
                name={typeOfCustomer + '.city'}
                value={config.city}
                onChange={onChangeFunc}
                className="validate"
                required={required}
              />
              <label htmlFor="financialContactCity">Plaats</label>
            </div>
          </div>
        </div>
        }

        <div className={'row'}>
          <div className={"input-field col s12 m6"} style={{display: (hideInput ? 'none' : 'inline-block')}}>
            <input
              type="email"
              ref={typeOfCustomer + '.email'}
              name={typeOfCustomer + '.email'}
              value={config.email}
              onChange={onChangeFunc}
              className={'validate'}
              pattern="^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,9}$"
              required={required}
              readOnly={this.isReadOnly('email')}
            />
            <label htmlFor="commercialContactEmail">{emailLabel}{required ? ' *' : ''}</label>
          </div>

          {sectionHeader.toLowerCase().includes('factuurgegevens') &&
          <div className={'row'}>
            <div className="input-field col s12 m6">
              <input
                ref="iban"
                type="text"
                name="iban"
                value={this.props.ibanValue}
                maxLength="18"
                className="validate"
                onChange={this.props.handleChange}
              />
              <label htmlFor="iban">IBAN</label>
            </div>
          </div>
          }

          {sectionHeader.toLowerCase().includes('factuurgegevens') &&
          <div className={'row'}>
            <div className="input-field col s12 m6">
              <input
                ref="btwNumber"
                type="text"
                name="btwNumber"
                value={this.props.btwNumber}
                className="validate"
                onChange={this.props.handleChange}
              />
              <label htmlFor="btwNumber">BTW nummer</label>
            </div>
            <div className="input-field col s12 m6">
              <input
                ref="bicCode"
                type="text"
                name="bicCode"
                value={this.props.bicCode}
                className="validate"
                onChange={this.props.handleChange}
              />
              <label htmlFor="bicCode">BIC code</label>
            </div>
          </div>
          }

          {!sectionHeader.toLowerCase().includes('factuurgegevens') &&
          <div className={isOdidoPortfolio && isCommercialContact ? "input-field col s6 m3" : "input-field col s12 m6"}
               style={{display: (hideInput ? 'none' : 'inline-block')}}>
            {this.props.telephoneNumberLimit ?
              (<input
                type="tel"
                name={typeOfCustomer + '.phoneNumber'}
                ref={typeOfCustomer + '.phoneNumber'}
                value={config.phoneNumber}
                onChange={onChangeFunc}
                className="validate"
                minLength="10"
                maxLength="10"
                pattern="^\d{10}"
                required={required}
                readOnly={this.isReadOnly('phone')}
              />) :
              (<input
                type="tel"
                name={typeOfCustomer + '.phoneNumber'}
                ref={typeOfCustomer + '.phoneNumber'}
                value={config.phoneNumber}
                onChange={onChangeFunc}
                className="validate"
                minLength="10"
                pattern="^\d+"
                required={required}
                readOnly={this.isReadOnly('phone')}
              />)
            }
            <label htmlFor="commercialContactPhone">Telefoonnummer {required ? ' *' : ''}</label>
          </div>
          }
          {isOdidoProvider && isCommercialContact &&
              <div className="col input-field s6 m3">
                <DatePicker
                    name={typeOfCustomer + '.birthdate'}
                    ref={typeOfCustomer + '.birthdate'}
                    className="validate nomarginbottom"
                    selected={config?.birthdate ? new Date(config?.birthdate) : ''}
                    onChange={this.onChangeBirthDate}
                    maxDate={new Date()}
                    onChangeRaw={e => e.preventDefault()}
                    dateFormat="dd-MM-yyyy"
                    noMinDate={true}
                    required={required}
                />
                <label htmlFor="birthdate">Geboortedatum{required ? ' *' : ''}</label>
              </div>
          }
          {/** needed for create new technical contract */}
          {/*<CreateNewTechnicalcontactModal*/}
          {/*    open={this.state.open}*/}
          {/*    close={this.handleCloseModal}*/}
          {/*    quotationId={quotation.id}*/}
          {/*    fillTechnicalContractFields={this.fillTechnicalContractFields}*/}
          {/*/>*/}

        </div>
      </div>
    );
  }
}

const mapStateToProps = ({customer, quotation}) => {
  return {
    customer,
    quotation: quotation.currentQuotation
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    infoActions: bindActionCreators(infoActions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(ContactInfo);
